import React, { useState } from "react";
import "../../../StyleSheet/AppComponent/Navbar/Navbar.scss";
import logo from "../../../Assets/AppComponent/Logo/Group 84.svg";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { getsidebarActions } from "../../../Redux/Slice";
import Logo1 from "../../../Assets/AppComponent/Logo/Group 85.png";
import { useNavigate } from "react-router-dom";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";

const Navbar = () => {
  const dispatch = useDispatch();
  let [isActive, setActive] = useState(false);
  const stateToogle = useSelector((state) => state.SideBarActive.SidebarActive);
  const navigate = useNavigate();
  const HandleSideToggle = () => {
    setActive(!isActive);
    dispatch(getsidebarActions(!stateToogle));
    //console.log(stateToogle, "dsafa");
  };
  const HandleClick = () => {
    $(".dropdown-menu").toggle();
  };
  $(".App").on("click", function () {
    $(".dropdown-menu").hide();
  });
  const handleLOgout = () => {
    window.location.reload();
    localStorage.clear();
    window.location.href = "/";
  };
  const UserData = useSelector((state) => state.users.UserData.data);

  return (
    <>
      <div className="header">
        <div className="rightSection">
          <div className="innerRight">
            <img
              style={{ cursor: "pointer" }}
              className={stateToogle ? "smallLogo transition" : "transition"}
              src={stateToogle ? logo : Logo1}
              alt="Logo"
              onClick={() => navigate("/")}
            />
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MenuOutlinedIcon
                onClick={HandleSideToggle}
                sx={{
                  color: "white",
                  width: 30,
                  height: 30,
                }}
              />
            </div>
          </div>
          <div className="innerProfilePic" onClick={HandleClick}>
            <img src={profile2} width={"45px"} height={"45px"} />
          </div>
        </div>
        <ul className="nav user-menu">
          <div className="NavMenuSet">
            <div className="NavMenus">
              <div className="User-Menu">
                <div className="dropdown-menu">
                  <div className="user-header">
                    <div
                      className="avatar avatar-sm"
                      // style={{ width: "48px", height: "50px" }}
                    >
                      <img
                        src={profile2}
                        alt="User Image"
                        className="avatar-img rounded-circle"
                        style={{ width: "60px", height: "60px" }}
                      />
                    </div>
                    <div className="user-text">
                      <h6>
                        <strong>User :&nbsp;</strong>
                        {UserData.first_name}
                      </h6>
                      <p className="">
                        <strong>Role :&nbsp;</strong>
                        {UserData.role}
                      </p>
                    </div>
                    <div className="logoutDiv">
                      <button className="custom-button" onClick={handleLOgout}>
                        Logout
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
